import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export default function NotFound({ title = "404", message = "This page took a wrong turn.", action }) {
  return (
    <div className="min-h-[60vh] grid place-items-center text-center" data-testid="not-found-page">
      <div>
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl grad-bg text-ink mb-6"><Zap size={24} /></span>
        <h1 className="font-heading text-5xl font-bold grad-text">{title}</h1>
        <p className="mt-3 text-white/60">{message}</p>
        <div className="mt-6 flex justify-center gap-3">
          {action}
          <Link to="/" className="btn-ghost" data-testid="not-found-home">Back to Command Center</Link>
        </div>
      </div>
    </div>
  );
}
